/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from "relay-runtime";

import { FragmentRefs } from "relay-runtime";
export type DataSourceProvider = "Google" | "Office365" | "%future added value";
export type DataSourceStatus = "Okay" | "RequiresReAuth" | "%future added value";
export type OnboardingPrivateCalendarSyncStep_user = {
    readonly id: string;
    readonly dataSources: {
        readonly edges: ReadonlyArray<{
            readonly node: {
                readonly id: string;
                readonly state: DataSourceStatus | null;
                readonly type: DataSourceProvider | null;
                readonly name: string | null;
                readonly " $fragmentRefs": FragmentRefs<"DataSource_dataSource">;
            } | null;
        } | null> | null;
    } | null;
    readonly " $refType": "OnboardingPrivateCalendarSyncStep_user";
};
export type OnboardingPrivateCalendarSyncStep_user$data = OnboardingPrivateCalendarSyncStep_user;
export type OnboardingPrivateCalendarSyncStep_user$key = {
    readonly " $data"?: OnboardingPrivateCalendarSyncStep_user$data | undefined;
    readonly " $fragmentRefs": FragmentRefs<"OnboardingPrivateCalendarSyncStep_user">;
};



const node: ReaderFragment = (function () {
    var v0 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "id",
        "storageKey": null
    } as any;
    return {
        "argumentDefinitions": [],
        "kind": "Fragment",
        "metadata": null,
        "name": "OnboardingPrivateCalendarSyncStep_user",
        "selections": [
            (v0 /*: any*/),
            {
                "alias": null,
                "args": [
                    {
                        "kind": "Literal",
                        "name": "first",
                        "value": 1000000
                    }
                ],
                "concreteType": "DataSourceConnection",
                "kind": "LinkedField",
                "name": "dataSources",
                "plural": false,
                "selections": [
                    {
                        "alias": null,
                        "args": null,
                        "concreteType": "DataSourceEdge",
                        "kind": "LinkedField",
                        "name": "edges",
                        "plural": true,
                        "selections": [
                            {
                                "alias": null,
                                "args": null,
                                "concreteType": "DataSource",
                                "kind": "LinkedField",
                                "name": "node",
                                "plural": false,
                                "selections": [
                                    (v0 /*: any*/),
                                    {
                                        "alias": null,
                                        "args": null,
                                        "kind": "ScalarField",
                                        "name": "state",
                                        "storageKey": null
                                    },
                                    {
                                        "alias": null,
                                        "args": null,
                                        "kind": "ScalarField",
                                        "name": "type",
                                        "storageKey": null
                                    },
                                    {
                                        "alias": null,
                                        "args": null,
                                        "kind": "ScalarField",
                                        "name": "name",
                                        "storageKey": null
                                    },
                                    {
                                        "args": null,
                                        "kind": "FragmentSpread",
                                        "name": "DataSource_dataSource"
                                    }
                                ],
                                "storageKey": null
                            }
                        ],
                        "storageKey": null
                    }
                ],
                "storageKey": "dataSources(first:1000000)"
            }
        ],
        "type": "User",
        "abstractKey": null
    } as any;
})();
(node as any).hash = '8038e594c2d31b193ac6d383b0b85984';
export default node;
